import { useContext, createElement, useCallback } from 'react';
import { ToggleIcon } from './toggle-icon';
import { ProTableSettingContext } from '../contexts/pro-table-setting-context';
export const ProTableZebraButton = () => {
    const { tableSetting, setTableSetting } = useContext(ProTableSettingContext);
    const handleClick = useCallback(() => setTableSetting((oldState) => ({
        ...oldState,
        isZebra: !oldState.isZebra,
    })), [setTableSetting]);
    return (createElement(ToggleIcon, { title: tableSetting.isZebra ? '隐藏斑马线' : '斑马线', type: tableSetting.isZebra ? 'table-zebra' : 'table-zebra', active: tableSetting.isZebra, onClick: handleClick }));
};
ProTableZebraButton.displayName = 'ProTableZebraButton';
